import { TIME_FORMAT_WITH_UTC } from 'config/constants';
import { usePlotViewQuery } from 'queries/scalings';
import { Dayjs, dayjs } from 'lib';
import { calculateDataAggregationWindow } from 'helpers';

type usePlotViewDataProps = { modelName?: string; start: Dayjs; end: Dayjs };

export const usePlotViewData = ({ modelName, start, end }: usePlotViewDataProps) => {
  const window = calculateDataAggregationWindow({
    dateRange: { start, end },
  });
  const { data, isLoading, error, isError } = usePlotViewQuery(
    {
      modelName,
      start_date: dayjs(start)?.utc().format(TIME_FORMAT_WITH_UTC),
      end_date: dayjs(end)?.utc().format(TIME_FORMAT_WITH_UTC),
      window,
    },
    { enabled: !!modelName || !!dayjs(start) || !!dayjs(end) },
  );

  return {
    data,
    dateRange: {
      start: dayjs(start).format(TIME_FORMAT_WITH_UTC),
      end: dayjs(end).format(TIME_FORMAT_WITH_UTC),
    },
    error,
    isLoading,
    isError,
  };
};
